import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-quantity" }
const _hoisted_2 = { class: "add-to-cart-counter" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityCounter',
  setup(__props) {

const internalValue = ref<number>(1);

const increment = () => {
  internalValue.value++;
};

const decrement = () => {
  if (internalValue.value > 0) {
    internalValue.value--;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        onClick: decrement,
        type: "button",
        class: "minusBtn",
        value: "-"
      }),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        size: "25",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
        class: "count"
      }, null, 512), [
        [_vModelText, internalValue.value]
      ]),
      _createElementVNode("input", {
        onClick: increment,
        type: "button",
        class: "plusBtn",
        value: "+"
      })
    ])
  ]))
}
}

})